import {createAction, props} from "@ngrx/store";
import {PaginatedRequestModel} from "@core/model/paginated-request.model";
import {PaginatedResultModel} from "@core/model/paginated-result.model";
import {RoleModel} from "@core/model/aux/role.model";
import {LOAD_ROLES, LOAD_ROLES_ERROR, LOAD_ROLES_SUCCESS} from "@core/ngrx/actions/aux/user.actions";
import {AuditLog} from "@core/model/audit-log";

export const LOAD_AUDITS = '[Audit List] Load Audits';
export const LOAD_AUDITS_SUCCESS = '[Audit List] Load Audits Success';
export const LOAD_AUDITS_ERROR = '[Audit List] Load Audits Error';


export const loadAudits = createAction(
  LOAD_AUDITS,
  props<{ params: PaginatedRequestModel }>()
);

export const loadAuditsSuccess = createAction(
  LOAD_AUDITS_SUCCESS,
  props<{ response: PaginatedResultModel<AuditLog> }>()
);

export const loadRolesError = createAction(
  LOAD_AUDITS_ERROR,
  props<{ msg: string }>()
);
